// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__1YDfq","wrapper":"Cell_wrapper__3C9kw"};